import { URL_REPLACEMENT } from '$const';
import { AssetId } from '~modules/media-library/model/Asset';
import { get } from '~services/api/methods';

export async function fetchSettings(realm: string, idCollection?: AssetId) {
  const params = new URLSearchParams();
  if (!!idCollection) {
    params.append('Collections', idCollection);
  }
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/settings/${realm}?${params}`;
  const response = await get(requestUrl);
  return response;
}
